import { render, staticRenderFns } from "./RHD_ShiPinXinXi.vue?vue&type=template&id=46d82a1d&"
import script from "./RHD_ShiPinXinXi.vue?vue&type=script&lang=js&"
export * from "./RHD_ShiPinXinXi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports